import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";

export default function useActiveUsers(clientId) {
  const [operators, setOperators] = useState([]);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    if (!clientId) return;
    const q = query(collection(db, "users"), where("clientId", "==", clientId));
    const unsub = onSnapshot(q, (snapshot) => {
      const ops = [];
      const custs = [];
      snapshot.forEach((doc) => {
        const user = doc.data();
        if (user.online) {
          if (user.role === "operator") ops.push(user);
          if (user.role === "customer") custs.push(user);
        }
      });
      setOperators(ops);
      setCustomers(custs);
    });
    return () => unsub();
  }, [clientId]);

  return { operators, customers };
}
